export const BASE_URL = `${process.env.REACT_APP_URL}` === 'dev' ? 'http://localhost:8002/api/v1/' : '/api/v1/';
